import { Us2Rocket } from '@uswitch/spark-icons/us2'
import React from 'react'

const UspIcon = ({ promotionType, className = '' }: { promotionType: string; className?: string }) => {
  if (promotionType === 'uswitch-award')
    return (
      <svg
        width='16'
        className={className}
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M2.14355 2.14355V13.8563H13.8563V2.14355H2.14355ZM11.3217 8.8972C11.3217 10.9595 10.0397 12.0518 7.9999 12.0518C5.96012 12.0518 4.67811 10.9595 4.67811 8.8972V3.94797H6.18308V8.90831C6.18308 10.1567 6.8631 10.7476 7.9999 10.7476C9.13671 10.7476 9.81672 10.157 9.81672 8.90831V3.94797H11.3217V8.8972Z'
          fill='#141424'
        />
        <path
          opacity='0.7'
          d='M5.85635 0L0 10.1437L10.1437 16L16 5.85635L5.85635 0ZM8 12.0519C6.00465 12.0519 4.67821 10.9596 4.67821 8.8973V3.94807H6.18318V8.90841C6.18318 10.1568 6.8632 10.7477 8 10.7477C9.1368 10.7477 9.81682 10.1571 9.81682 8.90841V3.94807H11.3218V8.8973C11.3218 10.9596 10.0398 12.0519 8 12.0519Z'
          fill='#141424'
        />
        <path
          opacity='0.4'
          d='M10.1437 0L0 5.85635L5.85635 16L16 10.1437L10.1437 0ZM8 12.0519C6.00465 12.0519 4.67821 10.9596 4.67821 8.8973V3.94807H6.18318V8.90841C6.18318 10.1568 6.8632 10.7477 8 10.7477C9.1368 10.7477 9.81682 10.1571 9.81682 8.90841V3.94807H11.3218V8.8973C11.3218 10.9596 10.0398 12.0519 8 12.0519Z'
          fill='#141424'
        />
      </svg>
    )

  if (promotionType === 'black-friday')
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
        <path
          d='M10 1.875L12.8769 6.99162L18.125 8.08195L14.655 12.3345L15.4078 18.125L10 15.6366L4.5922 18.125L5.345 12.3345L1.875 8.08195L7.12305 6.99162L10 1.875Z'
          fill='#FFF272'
        />
      </svg>
    )

  if (promotionType === 'next-gen-promotion' || promotionType === 'city-fibre-next-gen-promotion')
    return <Us2Rocket size={'24px'} />

  return null
}

export default UspIcon
